import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-check',
  templateUrl: './icon-check.component.html',
  styleUrls: ['./icon-check.component.scss'],
})
export class IconCheckComponent {
  @Input() width = 11;
  @Input() height = 9;
  @Input() color = '#fff';

  constructor() {}
}
